export default "__VITE_ASSET__f309cfcf__"